import { scope, vector } from '../instructions';
export var NAMES = scope('Names', 'Names', [
    scope('languages', 'languages', [vector('displayName', ['alt-key', 'language-id'])]),
    scope('scripts', 'scripts', [vector('displayName', ['alt-key', 'script-id'])]),
    scope('regions', 'regions', [vector('displayName', ['alt-key', 'region-id'])]),
]);
//# sourceMappingURL=names.js.map